import { DefaultBankAccountList, DefaultBankAccountRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchDefaultOperationalBankAccount() {
  const [fetching, setFetching] = useState(false);
  const [operationalBankAccount, setOperationalBankAccount] = useState<DefaultBankAccountList>();

  async function fetchDefaultOperationalBankAccount(params: DefaultBankAccountRequest) {
    try {
      setFetching(true);
      const res = await api.fetchDefaultBankAccount(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      const account = res.DefaultOperationalBankAccount?.[0];

      setOperationalBankAccount(account);

      return account;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, operationalBankAccount, fetchDefaultOperationalBankAccount };
}
